export const BrandStatus = {
  DRAFT: 0,
  PUBLISHED: 1,
  PENDING: 2,
  UNPUBLISHED: 3,
  PUBLISHING: 4,
};
